export type Scale = "tiny" | "small" | "medium" | "big" | "huge" | "gigantic";

export type PassedProps = {
  scale?: Scale;
};

export type MappedProps = {
  height?: string;
  width?: string;
};

const getSizeByScale = (scale?: Scale) => {
  switch (scale) {
    case "gigantic":
      return "4em";
    case "huge":
      return "2em";
    case "big":
      return "1.5em";
    case "medium":
      return "1.25em";
    case "tiny":
      return "0.85em";
    case "small":
      return "1em";
    default:
      return "1.5em";
  }
};

export const useMappedProps = ({
  scale,
  ...rest
}: PassedProps): MappedProps => ({
  ...rest,
  height: getSizeByScale(scale),
  width: getSizeByScale(scale),
});
